import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
  bannerRoot: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 80,
    background: `linear-gradient(90deg, ${theme.palette.greenLight} 0%, ${theme.palette.primary.main} 10%)`,
    color: theme.palette.common.white,
    zIndex: 1150,
  },
  bannerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    height: '100%',
    width: '100%',
    padding: theme.spacing(0, 5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 1.5),
    },
  },
  bannerLogo: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 128,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      order: 1,
      flex: '1 1 auto',
      justifyContent: 'center',
      width: '100%',
      marginTop: theme.spacing(1),
    },
  },
  bannerInfo: {
    backgroundColor: theme.palette.primary.hover,
    color: theme.palette.common.white,
    borderRadius: 8,
    padding: theme.spacing(0.5, 1),
    marginLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  bannerInfoText: {
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: 14,
    color: theme.palette.common.white,
    textAlign: 'left',
  },
  bannerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flex: 1,
    gap: theme.spacing(8),
    flexWrap: 'nowrap',
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      flexWrap: 'wrap',
      order: 2,
      width: '100%',
      alignItems: 'center',
    },
  },
  bannerLogoImage: {
    maxHeight: 50,
    objectFit: 'contain',
    display: 'block',
    filter: 'contrast(1.12) saturate(1.15)',
    [theme.breakpoints.down('sm')]: {
      maxHeight: 64,
    },
  },
  bannerTitle: {
    fontWeight: 700,
    fontSize: 24,
    fontFamily: 'Raleway',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip',
      fontSize: 18,
      marginBottom: theme.spacing(0.5),
    },
  },
  bannerCta: {
    whiteSpace: 'nowrap',
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: 15,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 120,
    maxWidth: 320,
    boxSizing: 'border-box',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'center',
      marginTop: theme.spacing(0.5),
      width: 'auto',
      minWidth: 72,
      padding: theme.spacing(0.25, 1),
      fontSize: 14,
      flexShrink: 0,
    },
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
      maxWidth: 'none',
      whiteSpace: 'normal',
      padding: theme.spacing(0.5, 0.75),
      fontSize: 12,
    },
  },
  bannerClose: {
    color: theme.palette.common.white,
    opacity: 0.8,
    '&:hover': {
      opacity: 1,
      backgroundColor: theme.palette.common.black,
    },
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
      width: 40,
      height: 40,
      zIndex: 2100,
    },
  },
}))

export default styles
